import Vue from 'vue';
import Router from 'vue-router';
const Login = () => import('./views/login/login.vue');
const Main = () => import('./views/main/main.vue');
const Agree = () => import('./views/agree/agree.vue');

import MainRouterChildren from "./views/main/main.router";

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/agree',
      name: 'agree',
      component: Agree

    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: MainRouterChildren
    },

  ],
});

export default router;
